export const SuccessMessage = {
  login: 'LOGIN_SUCCESS',
  gameClose: 'GAME_CLOSED_SUCCESS',
  betPlacedSuccessfully: 'BET_PLACED_SUCCESS',
  playerEscapedSuccessfully: 'PLAYER_ESCAPED_SUCCESS',
  betCancelledSuccessfully: 'BET_CANCEL_SUCCESS'
}

export const ErrorMessage = {
  internalServerError: 'INTERNAL_SERVER_ERROR',
  unAuthorized: 'UNAUTHORIZED'
}

export const errorCodeToMessage = new Map([
  [600, 'internalServerError'],
  [601, 'loginFailedError'],
  [602, 'invalidCredentialsError'],
  [603, 'invalidTokenError'],
  [604, 'invalidSessionError'],
  [605, 'invalidAccessError'],
  [606, 'nonOperationalError'],
  [2001, 'createUserError'],
  [2002, 'operatorNotExistsError'],
  [2003, 'operatorPlayerNotExists'],
  [2004, 'dataMismatchError'],
  [2005, 'userNotFoundError'],
  [2006, 'duplicateEmailError'],
  [2007, 'operatorUserIsBlocked'],
  [3010, 'InvalidCurrencyCodeError']
])
